import styled from 'styled-components';

const Text = styled.a`
  font-weight: 500;
  font-weight: 14px;
  color: ${(props) => props.theme.color.text};
  :hover {
    color: ${(props) => props.theme.color.text};
  }

  :active {
    color: ${(props) => props.theme.color.text};
  }
`;

export {
  Text,
};
